import { Button as ButtonMui } from '@mui/material';
import { Spacing } from '../../design-system/spacing';
import { toSpacing } from '../../utils/layout-spacing-props';
import { styled } from '../../utils/styled';

export const IconWrapper = styled('div')(() => ({
  width: 24,
  height: 24,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const buttonMarginProps = ['mr', 'ml', 'mt', 'mb', 'pl'];

export const StyledButton = styled(ButtonMui, {
  shouldForwardProp: (prop) => !buttonMarginProps.includes(String(prop)),
})<{
  mr?: string | number;
  ml?: string | number;
  mt?: string | number;
  mb?: string | number;
  pl?: string | number;
}>(({ variant, color, startIcon, theme, mr, ml, mt, mb, pl, ...rest }) => {
  // Calculate padding based on variant and presence of aria-label
  let padding = `${theme.spacing(Spacing.Small)}`;

  if (variant !== 'text') {
    if (rest['aria-label']) {
      padding = `${theme.spacing(Spacing.Small)} ${theme.spacing(Spacing.Medium)}`;
    } else {
      padding = `${theme.spacing(Spacing.Small)}`;
    }
  }

  // Update textDecoration and backgroundColor based on conditions
  let textDecoration = 'none';
  let backgroundColor;

  if (!(variant || startIcon)) {
    textDecoration = 'underline';
  }

  if (!(variant || startIcon || rest['aria-label'])) {
    backgroundColor = 'transparent';
  }

  return {
    height: theme.spacing(Spacing.XLarge),
    '&:hover': {
      textDecoration,
      backgroundColor,
      boxShadow: 'none',
    },
    '&:disabled': {
      border: 'none',
      backgroundColor: theme.palette.neutral[200],
    },
    borderRadius: theme.borderRadii.outer,
    textTransform: 'capitalize',
    color:
      variant === 'contained' && color === 'text'
        ? theme.palette.text.primaryInverted
        : undefined,
    padding,
    minWidth: '0px',
    boxShadow: 'none',
    border:
      variant === 'contained' && color !== 'error'
        ? `1px solid ${theme.palette.primary.main}`
        : undefined,
    marginRight: toSpacing(theme, mr),
    marginLeft: toSpacing(theme, ml),
    marginTop: toSpacing(theme, mt),
    marginBottom: toSpacing(theme, mb),
    paddingLeft: toSpacing(theme, pl),
    gap: theme.spacing(Spacing.Small),
  };
});
